import { deleteBlog } from './blog-events';

const blogPage = document.querySelector('#blog');

if (blogPage) {
  const deleteBlogBtn = document.querySelector('#blog #delete-btn');
  if (deleteBlogBtn) deleteBlogBtn.addEventListener('click', deleteBlog);
}
